import { useEffect, useState } from "react";
import { Mail, Send } from "lucide-react";
import api from "../lib/api";
import { toast } from "sonner";

// Founder-only tile that surfaces the Staff Hub weekly digest reach for
// last Monday, plus a 4-week rollup. Values come from
// `staff_hub_digest_runs` so the number is real (persisted after each
// send), not a projection. If no digest has ever run yet the tile shows
// a gentle "will run next Monday" hint instead of empty zeros.
export default function DigestReachTile() {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/staff-hub/digest/last-run")
    .then(r => setData(r.data && typeof r.data === "object" ? r.data : null))
    .catch(() => setData(null));
  useEffect(() => { load(); }, []);

  const runNow = async () => {
    setBusy(true);
    try {
      const { data: r } = await api.post("/staff-hub/digest/run-now");
      const safe = r || {};
      toast.success(safe.reason ? `Skipped · ${safe.reason}` : `Sent to ${safe.sent || 0} teammate${safe.sent === 1 ? "" : "s"}`);
      await load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
    finally { setBusy(false); }
  };

  const last = data?.last || null;
  const totals = data?.totals || { runs: 0, sent: 0, new_items: 0 };
  const stamp = last?.run_at ? new Date(last.run_at).toLocaleDateString(undefined, { day: "numeric", month: "short" }) : null;

  return (
    <div className="aii-card p-5 bg-gradient-to-br from-indigo-50 to-white border-indigo-200" data-testid="digest-reach-tile">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div>
          <div className="text-[10px] uppercase tracking-widest text-indigo-700 font-bold flex items-center gap-1"><Mail size={11}/> Staff Hub weekly digest</div>
          {last ? (
            <>
              <h3 className="font-display font-semibold text-lg mt-0.5">
                {last.sent || 0} teammate{last.sent === 1 ? "" : "s"} · {last.new_items || 0} new doc{last.new_items === 1 ? "" : "s"}
              </h3>
              <p className="text-xs text-[color:var(--aii-muted)] mt-0.5">
                Last sent {stamp} · {totals.runs} run{totals.runs === 1 ? "" : "s"} · {totals.sent} email{totals.sent === 1 ? "" : "s"} in the past 4 weeks
              </p>
            </>
          ) : (
            <>
              <h3 className="font-display font-semibold text-lg mt-0.5">Not yet sent</h3>
              <p className="text-xs text-[color:var(--aii-muted)] mt-0.5">Auto-fires every Monday 08:00 IST. Tap “Send now” to preview.</p>
            </>
          )}
        </div>
        <button onClick={runNow} disabled={busy} data-testid="digest-run-now"
                className="text-xs px-3 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 font-semibold flex items-center gap-1.5 disabled:opacity-50">
          <Send size={12}/> {busy ? "Sending…" : "Send now"}
        </button>
      </div>
    </div>
  );
}
